import React from 'react';
import PropTypes from 'prop-types';

import ProductBlogPost from 'Components/Product/Blog/ProductBlogPost';
import SiteSlider from 'Components/Utility/SiteSlider/SiteSlider';

const ProductBlogPostsCarousel = ({
  posts,
}) => {
  const sliderSettings = {
    xs: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    sm: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    md: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
    lg: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
    xl: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
    xxl: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
  };

  return (
    <div>
      <SiteSlider sliderSettings={sliderSettings}>
        {posts.map(post =>
          <ProductBlogPost post={post} key={post.id} />,
        )}
      </SiteSlider>
    </div>
  );
};

ProductBlogPostsCarousel.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object),
};

ProductBlogPostsCarousel.defaultProps = {
  posts: [],
};

export default ProductBlogPostsCarousel;
